import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {  CardContent, Card, TextField, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip,AppBar, Typography, Container, Toolbar, Box, Tooltip, IconButton,Avatar, Menu, MenuItem, Divider, Button, CircularProgress } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {theme} from '../helpers/colors'
import {stringAvatar,getStatusChipProps,processCSV} from '../helpers/utils'
import Fuse from 'fuse.js';
import _, { set } from 'lodash';
import {generateClient} from 'aws-amplify/api';
import { signOut } from 'aws-amplify/auth';
import cdkOutputs from '../helpers/cdk-output.json';
import backgroundImage from '../images/background_airbus.jpg';

//import { log } from 'console';

const LOGOUT_STRING='Logout';
const settings = [LOGOUT_STRING];
const STACK_NAME="DelegationCleanupStack"
const LandingPage = ({ fullName, email }) => {

    const [data, setData] = React.useState([]);
    const [hasLicense,setHasLicense] = React.useState(false);
    const IDENTITY_NAME = fullName;

    const fuseOptions = {
    includeScore: true,
    includeMatches: true,
    keys: ['userId', 'name', 'privilegeName', 'privilegeId', 'status'],
    threshold: 0.4
    };
    

    
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
    const [justLicensed,setJustLicensed]=React.useState(false);
    const [loading, setLoading] = React.useState(true); 
    const [isApproving,setIsApproving] = React.useState(false);
    const [messageError,setMessageError] = React.useState("");
    const [isError,setIsError] = React.useState(false);


    const clientGraphQL = generateClient();

    const navigate = useNavigate();
  

    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };
   
 
  
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };

    
    async function handleSignOut() {
      try {
        await signOut();
      } catch (error) {
        console.log('error signing out: ', error);
      }
    }


    const getStateQuery = { 
      query : `
        query GetState {
          GetState {
            statusCode,
            body{
              user_id,
              user_state
            },
            error
          }
        }
      `,
      authMode: 'userPool'
    };

    async function getStateFromAWS() {
      setLoading(true);
      try {
        const result = await clientGraphQL.graphql(getStateQuery);
        console.log('Query result:', result);
        if (result.data.GetState.statusCode==200){
          setIsError(false);
          (result.data.GetState.body.user_state ==1)? setHasLicense(true): setHasLicense(false)
        }else{
          setIsError(true);
          setMessageError("There was an error while retrieving account information.");
          console.error('Error calling query:', result.data.GetState.body.error);
        }
      } catch (error) {
        setIsError(true);
        setMessageError("There was an error while retrieving account information.");
        console.error('Error calling query:', error);
      } finally {
        setLoading(false); // Set loading to false when data is fetched or error occurs
      }
    }

    const approveLicenseMutation={
      query:`
      mutation ApproveLicense {
        ApproveLicense{
          statusCode,
          body{
            user_id,
            user_state
          },
          error
        }
      }
      `,
      variables:{
        input:email
      },
      authMode: 'userPool'
    }

    async function approveLicense() {
      setLoading(true);
      setIsApproving(true);
      try {
        const result = await clientGraphQL.graphql(approveLicenseMutation);
        console.log('Mutation result:', result);
        if (result.data.ApproveLicense.statusCode==200){
          setIsError(false);
          (result.data.ApproveLicense.body.user_state ==1)? setHasLicense(true): setHasLicense(false)
          setJustLicensed(true)
        }else if (result.data.ApproveLicense.statusCode==403){
          setIsError(true);
          setMessageError("The account you used isn't the one synchronized in Onelogin")
          console.log(result.data.ApproveLicense.error)
        }else{
          setIsError(true);
          setMessageError("There was an error while doing the activation");
        }
      } catch (error) {
        setIsError(false);
        setHasLicense(false);
        console.error('Error calling query:', error);
      } finally {
        setIsApproving(false);
        setLoading(false); // Set loading to false when data is fetched or error occurs
      }
    }
    
    
  
    const ContentMUI = () => {
      return (
        <ThemeProvider theme={theme}>
        <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: 'calc(100vh - 64px)', // Subtract AppBar height
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
          <Card sx={{ minWidth: 300, textAlign: 'center', p: 3, boxShadow: 'none' }}>
            <CardContent>
              <Typography variant="h4" component="div" gutterBottom sx={{ fontWeight: 'normal', mb: '10px' }}>
                Verification of your license
              </Typography>
              {loading?
                <div>
                <Typography variant="body2" sx={{ mb: '10px'}} color='airbus.light' gutterBottom>
                  {isApproving? "Activating": "Loading"}
                </Typography>
                <Box
                  sx={{
                    display: 'inline-flex',
                    borderRadius: '50%',
                    bgcolor: 'airbus.main',
                    p: 1,
                    mt: 0
                  }}
                >
                  <CircularProgress size={24} thickness={5} sx={{ color: '#ffffff' }} />
                </Box>
                </div>
                : isError?
                <div>
                  <Typography variant="body2" sx={{ mb: '10px'}} color='airbusError.light' gutterBottom>
                    {messageError}
                  </Typography>
                  <Box
                    sx={{
                      display: 'inline-flex',
                      borderRadius: '50%',
                      bgcolor: 'airbusError.main',
                      p: 1,
                      mt: 0
                    }}
                  >
                    <ClearIcon size={24} thickness={5} sx={{ color: '#ffffff' }} />
                  </Box>
                </div>
                : justLicensed?
                  <div>
                <Typography variant="body2" color='airbus.light' gutterBottom>
                   Your license is now active
                </Typography>
                <Box
                  sx={{
                    display: 'inline-flex',
                    borderRadius: '50%',
                    bgcolor: 'airbus.main',
                    p: 1,
                    mt: 0
                  }}
                >
                  <CheckIcon size={24} thickness={5} sx={{ color: '#ffffff' }} />
                </Box>
                </div>
                  :
                  hasLicense?
                    <div>
                      <Typography variant="body2" sx={{ mb: '10px'}} color='airbus.light' gutterBottom>
                        Your Onelogin license is already activated
                      </Typography>
                      <Box
                        sx={{
                          display: 'inline-flex',
                          borderRadius: '50%',
                          bgcolor: 'airbus.main',
                          p: 1,
                          mt: 0
                        }}
                      >
                        <CheckIcon size={24} thickness={5} sx={{ color: '#ffffff' }} />
                      </Box>
                  </div>
                :
                <div>
                    <Typography variant="body2" sx={{ mb: '10px'}} color='airbus.light'  gutterBottom>
                         Your Onelogin license is not active. Please click on the button bellow to activate.
                    </Typography>
                    
                    <Button
                        variant="contained"
                        color='airbus'
                        onClick={() => approveLicense()}>
                          Activate
                    </Button>
                </div>
               } 
            </CardContent>
          </Card>
        </Box>
        </ThemeProvider>
      );
    };
    


  useEffect(() => {
    getStateFromAWS();
  }, []);
  
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
    <ThemeProvider theme={theme}>
      <AppBar position="static">
      <Container maxWidth="xl">
      <Toolbar disableGutters>
        <svg xmlns="http://www.w3.org/2000/svg" className='airbus-icon' width="126" height="24" viewBox="0 0 640 121.8344">
                <defs id="defs4"></defs>
                <g id="g44809" transform="matrix(5.5695687,0,0,5.5695687,-2558.8034,-4448.4754)">
                    <path d="m 526.05468,815.67559 -7.26563,0 0,-4.07812 7.26953,0 c 1.19532,0.0195 2.16016,0.91406 2.16016,2.03125 0,1.11719 -0.96875,2.04687 -2.16406,2.04687 m -7.26563,-11.95703 7.14063,0 c 0.97656,0.0117 1.80468,0.76563 1.80468,1.75391 0,0.98437 -0.86718,1.76953 -1.84765,1.75781 l -7.09766,0 z m 11.3711,5.70313 c 1.34375,-0.94531 1.85156,-2.51172 1.85156,-4.23438 0,-3.24218 -2.73047,-5.83984 -6.07813,-5.83984 l -12.125,0 0,20.69922 12.60157,0 0,0.008 c 3.53906,0 6.48437,-2.73047 6.48437,-6.07422 0,-2.17969 -1.3125,-3.79297 -2.73437,-4.55859 m 18.69921,-10.1211 0,11.63672 c 0,3.5586 -2.07812,5.05078 -4.63281,5.05078 -2.55859,0 -4.62109,-1.48828 -4.62109,-5.04687 l 0,-11.64063 -5.16016,0 0,11.67188 c 0,7.44531 4.375,9.61328 9.78125,9.61328 5.41016,0 9.78906,-2.16797 9.78906,-9.61328 l 0,-11.67188 z m 18.10547,8.06641 c -4.17578,-0.90625 -5.58593,-1.30859 -5.58593,-2.63281 0,-1.16797 1.51171,-1.75781 3.89843,-1.75781 2.25391,0 4.97657,0.96093 6.57422,1.91796 l 1.62891,-4.21093 c -2.42188,-1.00782 -5.33594,-1.97266 -9.1875,-1.97266 -5.05078,0 -8.20313,2.95313 -8.20313,6.5625 0,3.61328 2.59766,5.20313 7.7461,6.29297 3.99218,0.84375 5.07422,1.35156 5.07422,2.59375 0,1.24219 -1.60157,1.69922 -3.76563,1.69922 -2.80078,0 -5.49609,-0.9336 -8.03516,-2.02344 l -1.53515,4.10528 c 3.03515,1.40625 6.1875,2.53516 9.94531,2.53516 6.26172,0 8.81641,-2.99219 8.81641,-6.48047 0,-3.10157 -2.14844,-5.49219 -7.3711,-6.62891 m -97.08203,-8.01953 -10.45703,20.69531 6.21094,0.004 1.5625,-3.32813 7.13281,0 -2.21875,-4.53515 -2.81641,0 2.65235,-5.66016 6.67969,13.52344 6.22656,0 -10.86328,-20.69922 z m 42.01563,6.88281 c 0,-3.76953 -2.58594,-6.82812 -7.90235,-6.82812 l -10.73828,0 0,20.69922 4.97656,-0.004 0,-16.32422 6.10547,0 c 1.80469,0 2.55469,1.11719 2.55469,2.44531 0,1.33203 -0.78906,2.39844 -2.59375,2.39844 l -4.26953,0 6.46094,11.48047 5.10937,0 c 0,0 -4.42187,-7.50391 -4.39844,-7.50781 3.19141,-0.99219 4.69532,-3.41016 4.69532,-6.35938 m -25.97657,13.82422 5.14844,0 0,-20.69531 -5.14844,0 z" id="path28794" ></path>
                </g>
            </svg>
          
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', ml: 2, flexGrow: 1 }}>
              <Typography variant="h6" noWrap component="div" sx={{ fontFamily: 'monospace', fontWeight: 700, letterSpacing: '.3rem', color: 'inherit', textDecoration: 'none' }}>
              License Recovery
              </Typography>
            </Box>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            </Box>

          <Box sx={{ flexGrow: 0 }}>
          <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar  alt={IDENTITY_NAME} {...stringAvatar(IDENTITY_NAME)} />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              PaperProps={{  
                style: {  
                  width: 250,  
                },  
             }} 
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
                <Box elevation={3} sx={{  display: 'flex',justifyContent: 'center', }}>
                    <Avatar  style={{margin:'20px'}} alt={IDENTITY_NAME} {...stringAvatar(IDENTITY_NAME)} />
                    <span style={{margin:'20px'}}>{IDENTITY_NAME}</span>
                </Box>
                <Divider/>
                {settings.map((setting) => (
                  <MenuItem
                    sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}
                    key={setting}
                    onClick={setting === LOGOUT_STRING ? handleSignOut : handleCloseUserMenu}
                  >
                    <Typography sx={{ width: '100%' }} textAlign="center">
                      {setting}
                    </Typography>
                  </MenuItem>
                ))}
            </Menu>
          </Box>
          </Toolbar>
          </Container>
      </AppBar>
      </ThemeProvider>
        <ContentMUI />
    </div>
  );
};

export default LandingPage;